<template>
    <section>
        <select v-model="order">
            <option value="0" selected>新しい順</option>
            <option value="1">古い順</option>
        </select>
        <ul id="thread">
            <li v-for="thread in thread_list" class="screen-transition" @click="select(thread.thread_id, $event)">
                <div class="created_at"><p>投稿日時：{{ thread.date }}</p></div>
                <div class="thread-title"><p>タイトル：{{ thread.title }}</p></div>
                <div class="thread-owner"><p>作成者：{{ thread.owner }}</p></div>
                <div class="thread-lgtm"><p>スレッドに対するいいね数：{{ thread.lgtm }}</p></div>
                <div class="thread-comment"><p>スレッドに対するコメント数：{{ thread.comment_count }}</p></div>
                <div class="thread-sum-comment"><p>総コメント数：{{ thread.sum_comment_count }}</p></div>
                <img src="/image/icons/next.png">
            </li>
        </ul>
        <div>
            <form id="icon_form">
                <p>アイコンを設定する</p>
                <input type="file" name="icon" @change="selectedFile">
                <p @click="submitIconForm">送信する</p>
            </form>
        </div>
    </section>
</template>

<script>
    export default {
        name: "thread-list",
        props: ['topic_id', 'json_characters'],
        mounted() {
            this.getThread();
            this.characters = JSON.parse(this.json_characters);
        },
        data: function () {
            return {
                thread_list: [],
                order: 0,
                characters: Object,
                uploadFile: undefined,
            }
        },
        methods: {
            select: function (s, event) {
                console.log(s);
                if (s) {
                    const id = String(s);
                    location.href = `/thread/detail?thread_id=${id}`;
                }
            },
            getThread: function () {
                axios.default
                    .get(`/thread/list?topic_id=${this.topic_id}&order=${this.order}`)
                    .then(response => {
                        if(this.thread_list.length == 0) {
                            this.thread_list = response.data;
                        } else {
                            this.thread_list = this.thread_list.concat(response.data);
                        }
                    });
            },
            submitIconForm: function() {
                const data = new FormData();    // multipart/form-data形式のため、new FormData()を使う
                data.append('icon', this.uploadFile);

                axios.default
                    .post(`/member/icon`, data)
                    .then(response => {
                    });
            },
            selectedFile: function(e) {
                e.preventDefault();
                this.uploadFile = e.target.files[0];    // fileにはreadonly制約があり、v-modelは使えない。代わりにchangeイベントが推奨されている
            },
        },
        watch: {
            order: function (newIndex, oldIndex) {
                this.thread_list = [];
                this.getThread();
            }
        }
    }
</script>

<style scoped>

</style>
